import type { Renderer } from './renderer';

// istanbul ignore next
const loadRenderer = async (): Promise<Renderer> => {
  const renderer = await import(/* webpackChunkName: "3-render-renderer" */ './renderer');

  return renderer.default;
};

export default loadRenderer;
